<template>
  <div class="navbar">
    <div v-if="sidebar.opened && device === 'desktop'" class="navbar-logo">
      <img :src="logo" alt="" />
    </div>
    <hamburger
      :is-active="sidebar.opened"
      class="hamburger-container"
      @toggleClick="toggleSideBar"
    />
    <div class="navbar-title">康宝莱服务提供商发票审核系统</div>

    <div class="right-menu">
      <el-dropdown class="avatar-container" trigger="click">
        <div class="avatar-wrapper">
          <img :src="userIcon" class="user-avatar" />
          <span v-if="sidebar.opened && device === 'desktop'" class="avatar-name">{{ name }}</span>
          <i class="el-icon-caret-bottom" />
        </div>
        <el-dropdown-menu slot="dropdown" class="user-dropdown">
          <el-dropdown-item @click.native="logout">
            <span style="display: block">退出</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Hamburger from '@/components/Hamburger'

export default {
  components: {
    Hamburger
  },
  computed: {
    ...mapGetters(['sidebar', 'avatar', 'logo', 'name', 'userIcon']),
    device() {
      return this.$store.state.app.device
    }
  },
  methods: {
    toggleSideBar() {
      this.$store.dispatch('app/toggleSideBar')
    },
    async logout() {
      await this.$store.dispatch('user/logout')
      // this.$router.push(`/login?redirect=${this.$route.fullPath}`)
      this.$router.push(`/`)
    }
  }
}
</script>

<style lang="scss" scoped>
.navbar {
  height: 50px;
  overflow: hidden;
  position: relative;
  background: #ffffff;
  display: flex;
  // background: #fff;
  box-shadow: 0px 0px 5px 0px rgba(78, 92, 108, 0.2);
  .navbar-logo {
    width: 210px;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      width: 135px;
      margin-left: -50px;
      // display: block;
    }
  }
  .navbar-title {
    color: #4e5c6c;
    font-size: 15px;
    line-height: 50px;
  }
  .hamburger-container {
    line-height: 46px;
    height: 100%;
    cursor: pointer;
    transition: background 0.3s;
    -webkit-tap-highlight-color: transparent;
    margin-right: 20px;
  }

  .breadcrumb-container {
    float: left;
  }

  .right-menu {
    float: right;
    height: 100%;
    line-height: 50px;
    display: flex;
    margin-left: auto;

    &:focus {
      outline: none;
    }

    .right-menu-item {
      display: inline-block;
      padding: 0 8px;
      height: 100%;
      font-size: 18px;
      color: #5a5e66;
      vertical-align: text-bottom;

      &.hover-effect {
        cursor: pointer;
        transition: background 0.3s;

        &:hover {
          background: rgba(0, 0, 0, 0.025);
        }
      }
    }

    .avatar-container {
      margin-right: 30px;
      display: flex;
      align-items: center;
      .avatar-wrapper {
        display: flex;
        align-items: center;
        position: relative;
        color: #4e5c6c;
        .user-avatar {
          cursor: pointer;
          width: 25px;
          height: 25px;
        }
        span {
          margin: 0px 5px;
          font-size: 14px;
        }
        .el-icon-caret-bottom {
          cursor: pointer;
          font-size: 15px;
        }
      }
      .avatar-wrapper:hover {
        color: #76b42f;
      }
    }
  }
}
</style>
